import { templates as basicRoutes } from "./basic"
import { templates as libraryRoutes } from "./library"
import { templates as assessmentsRoutes } from "./assessments"
import { templates as deliveringRoutes } from "./delivering"
import { templates as markingRoutes } from "./marking"
import { templates as reportsRoutes } from "./reports"
import { templates as administrationRoutes } from "./administration"
import { templates as wizardRoutes } from "./wizard"

// TODO: add validate function that verify all child routes has parent route as substring at the start of string
export const buildRouteTemplates = () => {
  return [
    ...basicRoutes,
    libraryRoutes,
    assessmentsRoutes,
    deliveringRoutes,
    markingRoutes,
    reportsRoutes,
    administrationRoutes,
    wizardRoutes,
  ]
}
